<template>
  <ErrorBoundary>
    <Card>
      <div class="card-body text-center">
        <div>
          <h6 class="text-left text-[1.125rem]">
            {{ t('product.show.checkout.corporateGiftRequest.title') }}
          </h6>
          <p class="mt-2 text-left text-sm">
            {{ t('product.show.checkout.corporateGiftRequest.description') }}
          </p>
        </div>

        <Button
          variant="outlined"
          class="p-2 w-full mt-4 group flex justify-center"
          data-test-id="corporate-gift-request-button"
          link="https://share-eu1.hsforms.com/1ltkibOaNThaZDN40JuR-yAewif8"
          open-new-tab
        >
          <span class="flex justify-center items-center relative gap-1">
            <Gift class="stroke-[1.7]" />
            <span>
              {{ t('product.show.checkout.corporateGiftRequest.contactUs') }}
            </span>
            &gt;
          </span>
        </Button>
      </div>
    </Card>
  </ErrorBoundary>
</template>
<script setup lang="ts">
import { Gift } from 'lucide-vue-next'
const { t } = useI18n()
</script>
